var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconly/Light/Filter"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Filter"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1",
    d: "M17.2168 27.6548H6.71564",
    stroke: "#130F26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 3",
    d: "M21.9009 11.5005H32.4021",
    stroke: "#130F26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9997 11C12.9997 9.34333 11.6563 8 9.99967 8C8.343 8 6.99967 9.34333 6.99967 11C6.99967 12.6567 8.343 14 9.99967 14C11.6563 14 12.9997 12.6567 12.9997 11Z",
    fill: "#FC5C42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5438 11.4104C14.5438 9.251 12.7802 7.5 10.6052 7.5C8.43027 7.5 6.66667 9.251 6.66667 11.4104C6.66667 13.5698 8.43027 15.3208 10.6052 15.3208C12.7802 15.3208 14.5438 13.5698 14.5438 11.4104Z",
    stroke: "#130F26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9997 28C33.9997 26.3433 32.6563 25 30.9997 25C29.343 25 27.9997 26.3433 27.9997 28C27.9997 29.6567 29.343 31 30.9997 31C32.6563 31 33.9997 29.6567 33.9997 28Z",
    fill: "#FC5C42"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3331 27.5891C33.3331 25.4297 31.5709 23.6787 29.3959 23.6787C27.2196 23.6787 25.456 25.4297 25.456 27.5891C25.456 29.7486 27.2196 31.4996 29.3959 31.4996C31.5709 31.4996 33.3331 29.7486 33.3331 27.5891Z",
    stroke: "#130F26",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.18ce5968.svg";
export { ForwardRef as ReactComponent };